var courseModule = angular.module('t2g.course', [
  'gettext',
  'ui.router',
  require('t2g.common.services.modalService').name,
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.notificationService').name,
]);

module.exports = courseModule;

courseModule.controller('CourseListCtrl', require('./list/listCtrl.js'));
courseModule.controller('CourseModalCtrl', require('./modal/courseModalCtrl.js'));

courseModule.config(function($stateProvider) {
  $stateProvider.state('private.main.courses', {
    url: '/courses',
    title: 'Courses',
    templateUrl: '/app/modules/course/list/CourseListView.html?v=4.5.6',
    controller: 'CourseListCtrl',
    resolve: {
      officeResolve: function(OfficeDA) {
        return OfficeDA.get();
      },
    },
  });
});



// WEBPACK FOOTER //
// ./src/app/modules/course/courseModule.js